export default __webpack_public_path__ + "static/media/invoice-column-active.e3c3ab4d.svg";